import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { techStackDetails } from "../Details";

function Technologies() {
  const {
    html,
    css,
    js,
    ts,
    php,
    react,
    tailwind,
    bootstrap,
    phpstorm,
    vscode,
    git,
    github,
    // npm,
    postman,
  } = techStackDetails;
    
    const techs = useRef();
    const tools = useRef();
    
    useEffect(() => {
      const tl = gsap.timeline();
      
      tl.from(
          techs.current,
          {
            x: "-100%",//from left
            delay: 0.2,
            opacity: 0,
            duration: 1,
            ease: "Power3.easeOut",
          },
          "<"
        )
        .from(
          tools.current,
          {
            x: "200%",//from right
            delay: 0.2,
            opacity: 0,
            duration: 1,
            ease: "Power3.easeOut",
          },
          "<"
        );
    }, []);
  return (
    <main className="container mx-auto max-width pt-10 pb-20 ">
      <div ref={techs}> 
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tech Stack
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Beberapa teknologi yang pernah dan masih saya gunakan:
        </p>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={html} title="html" alt="" />
        <img src={css} title="CSS" alt="" />
        <img src={js} title="JavaScript" alt="" />
        <img src={ts} title="TypeScript" alt="" />
        <img src={php} title="PHP" alt="" />
        <img src={bootstrap} title="Bootstrap" alt="" />
        <img src={tailwind} title="Tailwind CSS" alt="" />
        <img src={react} title="React" alt="" />
      </section>
      </div>
      <div ref={tools}> 
      <section>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tools
        </h1>
      </section>
      <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
        <img src={vscode} title="Visual Studio Code" alt="" />
        <img src={phpstorm} title="Phpstorm" alt="Phpstorm" />
        <img src={git} title="Git" alt="Git" />
        <img src={github} title="Github" alt="Github" />
        {/* <img src={npm} title="NPM" alt="NPM" /> */}
        <img src={postman} title="Postman" alt="Postman" />
      </section>
      </div>
    </main>
  );
}

export default Technologies;
